export { HeroAdvancedAdditionalContent } from './hero-advanced-additional-content';
